import React, { Fragment } from "react"

import {
  AccordionComponent as Accordion,
  Summary,
  Details,
  Text,
} from "components/ui/Accordion"

const Content = () => {
  return (
    <Fragment>
      <Accordion>
        <Summary>Küpsiste kasutamise pöhimötted</Summary>
        <Details>
          <Text>
            Küpsiste kasutamise pöhimötted Küpsis (cookie) on väike andmefail,
            mis salvestatakse kasutaja seadmetesse. Küpsiseid kasutatakse
            statistiliste andmete kogumiseks ja analüüsiks, näiteks annavad need
            info kasutaja keelevaliku, tootevaliku voi muu eelistuse kohta.
            Saadud info aitab meil taiustada veebilehe kasutajamugavust.
          </Text>
          <Text>
            Saadud info aitab meil taiustada veebilehe kasutajamugavust. Punk
            Finance veebilehel kasutatakse järgmiseid küpsiseid:
            <ul>
              <li>
                Punk Finance veebilehel kasutatakse järgmiseid küpsiseid:
                Seansiküpsised (session cookies) - salvestatakse seadmesse vaid
                veebilehe külastamise ajaks ning kustutatakse veebilehe
                sulgemisel automaatselt.
              </li>
              <li>
                Seansiküpsised (session cookies) - salvestatakse seadmesse vaid
                veebilehe külastamise ajaks ning kustutatakse veebilehe
                sulgemisel automaatselt. Seansiküpsiste mitteaktsepteerimisel ei
                ole voimalik veebilehte kasutada.
              </li>
              <li>
                Seansiküpsiste mitteaktsepteerimisel ei ole voimalik veebilehte
                kasutada. Püsivad küpsised (persistent cookies) - salvestatakse
                seadmesse teatud perioodiks.
              </li>
              <li>
                Püsivad küpsised (persistent cookies) - salvestatakse seadmesse
                teatud perioodiks. Kasutaja saab need soovi korral oma seadme
                turvasätete alt eemaldada
              </li>
            </ul>
          </Text>
          <Text>
            Kasutaja saab need soovi korral oma seadme turvasätete alt eemaldada
            Punk Finance veebilehel kasutatakse ka kolmandate osapoolte
            küpsiseid, nendeks on näiteks Google Ads Remarketing Tag', Google
            Ads Tag, Facebook Pixel, LinkedIn Insight Tag ning Twitter Pixel.
            Kolmanda osapoolte küpsiste tingimustega on vöimalik tutvuda nende
            enda kodulehtedel.
          </Text>
        </Details>
      </Accordion>
    </Fragment>
  )
}

export default Content
